<template>
  <div class="flex flex-col h-screen">
    <Header />
    <div class="z-10 flex flex-1 overflow-hidden">
      <Sidebar v-if="renderDesktopSidebar" />
      <main scroll-region class="flex-1 w-full overflow-y-scroll">
        <DefaultPageWrapper v-if="renderDefaultPageWrapper">
          <slot />
        </DefaultPageWrapper>
        <slot v-else />
      </main>
    </div>

    <FlashMessage class="mt-20" />

    <GoogleTagManagerScripts
      v-if="props.tenant.company.google_tag_manager_id"
      :googleTagManagerId="props.tenant.company.google_tag_manager_id"
    />
  </div>
</template>

<script setup>
import { ref, provide, computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

import FlashMessage from '@/Components/Shared/FlashMessage'
import Header from '@/Components/Customer/Header/Header'
import Sidebar from '@/Components/Customer/Sidebar/Sidebar'
import DefaultPageWrapper from '@/Components/Company/PageWrapper/DefaultPageWrapper'

import GoogleTagManagerScripts from '@/Components/Customer/OrderForms/LayoutParts/GoogleTagManagerScripts'

const { props } = usePage()

const renderDesktopSidebar = computed(() => props.value.meta?.renderDesktopSidebar ?? true)

const renderDefaultPageWrapper = computed(() => props.value.meta?.renderDefaultPageWrapper ?? true)

const sidebarOpen = ref(false)
provide('sidebarOpen', sidebarOpen)

const toggleSidebarOpen = () => (sidebarOpen.value ^= true)
provide('toggleSidebarOpen', toggleSidebarOpen)
</script>
